// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCZEnudnGZOg6J1XsQqvCbgmEfpdp86XTY",
    authDomain: "transform-ab34b.firebaseapp.com",
    projectId: "transform-ab34b",
    storageBucket: "transform-ab34b.appspot.com",
    messagingSenderId: "392370155351",
    appId: "1:392370155351:web:bf25d7edd5c4c5bccbd812",
    measurementId: "G-NMJQGQSTLF"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;